export default {
  drafts: {
    title: 'Invoices without issuing',
    edit: 'Edit invoice',
    view: 'Show invoice',
    duplicate: 'Duplicate',
    issue: 'Issue invoice',
    sendProForm: 'Send Pro Forma',
    history: 'Historical',
    deleteTitle: 'Delete selected draft',
    deleteConfirm: 'Are you sure you want to delete the selected draft?',
    download: 'Download',
    requestText: 'The issuance of invoices has been requested. You can check the invoices issued in the Issued and Received menu, both as a provider and as a payer. From this screen you can see the detail of an invoice, manage its collection or download it in different formats'
  },
  newInvoice: {
    dataTitle: 'General data',
    detailsTitle: 'Invoice details',
    paymentTitle: 'Discounts and payment methods',
    summaryTitle: 'Summary',
    stepBack: 'Go to previous step',
    saveAsDraft: 'Save as draft',
    factoringTitle: 'Factoring data',
    validationError: 'An invoice validation error has occurred',
    factoring: {
      messageOk: 'The financing has been requested correctly',
      messageKo: 'The financing request could not be sent, try again later from the "Financing" tab'
    },
    alertCaixaThirdPartyClientWithLink: 'Invoices addressed to CaixaBank, do not allow the creation of third party invoices',
    alertTxtMortgageExpenses: 'To issue an invoice to this department, you must do it from the CaixaBank Providers Portal',
    alertBFA: `As a result of the merger between Bankia, S.A. and CaixaBank, S.A. on March 26th, BFA has taken over directly the management of all services 
    related to the execution of its activity in an autonomous and independent manner.<br/><br/>We anticipate you the e-mail address created for the interlocution 
    during the provision of its services and that we kindly ask you to use from now on as the main means of communication between the parties: 
    <a href="mailto:informacion@bfa.com.es">informacion@bfa.com.es</a><br/><br/>In those exceptional cases in which the above is not possible, you may also 
    contact BFA's head office:<br/><div style="text-align:center"><span>BFA TENEDORA DE ACCIONES S.A.<br/>AVENIDA GENERAL PERON, 38<br/>EDIFICIO MASTER II<br/>
    28020 MADRID</span></div><br/>We thank you in advance for your cooperation and remain at your disposal for any clarification you may require.`,
    alertPension: 'To issue an invoice to this entity, you must do it from the CaixaBank Providers Portal'

  },
  autodrafts: {
    title: 'Selfinvoice without issuing',
    edit: 'Edit selfinvoice'
  },
  thirdParty: {
    title: 'Supplied and third parties without issuing'
  },
  ok: '<span style="font-size: 20px;">In order to finish the process we have sent you an <span style="font-weight: bold">email to {0}</span> to activate your account.</span>'
}
